import React from "react";
import Button from "../../buttons/Button";
import Popover from "../../popover/Popover";
import PopoverContentContainer from "../../popover/PopoverContentContainer";
import { getIcon } from "../../../util/StyleSettingsUtil";
import { MELOGY_TRANSPARENT } from "../../../style/colors";
import styled from "styled-components";

const SubgroupList = styled.div`
    display: flex;
    flex-direction: column;
`;

const SubgroupSelection = ({
    selectedGroup,
    subgroups,
    onSelectSubgroup,
    onClose,
}) => {
    return (
        <Popover
            backdropHeight="calc(100vh - 212px)"
            content={
                <PopoverContentContainer
                    title={selectedGroup}
                    component={
                        <SubgroupList>
                            {subgroups.map((subgroup) => (
                                <Button
                                    key={subgroup}
                                    text={subgroup}
                                    height="32px"
                                    width="168px"
                                    justifyContent="flex-start"
                                    buttonColor="white"
                                    borderBottom="0"
                                    onClick={() => onSelectSubgroup(subgroup)}
                                    icon={getIcon(subgroup, "white")}
                                />
                            ))}
                        </SubgroupList>
                    }
                />
            }
            onClose={onClose}
            zIndex={1000}
        />
    );
};

export default SubgroupSelection;
